@if (showBanner) {
  <div
    class="bg-color-white u-display-block u-padding-8 u-margin-8-0 u-border-orange u-borderRadius--4px"
  >
    <div fxLayout="row" fxLayoutGap="8px">
      <div fxLayout="column" fxLayoutAlign="start start">
        <mat-icon class="color-orange">error</mat-icon>
      </div>
      <div fxLayout="column">
        <p i18n="@@csvAttributeMappings.alert.body">
          The following fields need approval. You can review and approve them,
          or skip importing them into 10KC.
        </p>
        <p i18n="@@csvAttributeMappings.alert.subBody">
          Fields that need approval: {{ unReviewedFields }}
        </p>
      </div>
    </div>
  </div>
}
<div class="bg-color-white u-card mat-elevation-z1">
  <div class="u-padding-16">
    <p class="text-subtitle-1" i18n="@@csvAttributeMappings.Title">
      Map CSV columns to 10KC fields
    </p>
    <p
      class="u-text-maxWidth u-paddingTop-8 text-body-2"
      i18n="@@csvAttributeMappings.firstSubTitle"
    >
      CSV columns have been mapped to 10KC fields.
    </p>
    <p
      class="u-text-maxWidth u-paddingTop-4 text-body-2"
      i18n="@@csvAttributeMappings.secondSubTitle"
    >
      <b>Review and approve</b> each mapping to continue to approve member
      updates.
    </p>
  </div>
  <nz-table
    #csvAttributeMappingTable
    [nzData]="visibleUniqueColumns"
    [nzFrontPagination]="false"
    [nzLoading]="isLoading"
    [nzScroll]="{ x: '100%', y: '400px' }"
    class="u-padding-16"
    nzOuterBordered
    [nzSize]="$any('medium')"
  >
    <thead>
      <tr>
        <th
          nzWidth="20%"
          i18n="@@csvAttributeMappings.csvAttributeTable.import"
        >
          Import
        </th>
        <th
          [nzSortFn]="'name' | appMakeSortStringFn"
          nzWidth="60%"
          i18n="@@csvAttributeMappings.csvAttributeTable.csvField"
        >
          CSV field
        </th>
        <th nzWidth="10%">
          <mat-icon class="material-symbols-outlined md-16">
            arrow_forward
          </mat-icon>
        </th>
        <th
          [nzSortFn]="'translation' | appMakeSortStringFn"
          nzWidth="40%"
          i18n="@@csvAttributeMappings.csvAttributeTable.10kcfield"
        >
          10KC field
        </th>
        <th
          nzWidth="40%"
          i18n="@@csvAttributeMappings.csvAttributeTable.mappingStatus"
        >
          Mapping status
        </th>
        <th nzWidth="40%">
          <button
            [disabled]="!canApproveAll()"
            (click)="approveAllAttributeMappings()"
            color="primary"
            mat-stroked-button
            i18n="@@csvAttributeMappings.csvAttributeTable.approveAll"
          >
            Approve all
          </button>
        </th>
      </tr>
    </thead>
    <tbody>
      @for (data of csvAttributeMappingTable.data; track data.name) {
        <tr>
          <td>
            <label
              [disabled]="isRequired(data.translation)"
              [ngModel]="!data.skip"
              (ngModelChange)="setSkipStatus(data.name, !$event)"
              nz-checkbox
            ></label>
          </td>
          <td>{{ data.name }}</td>
          <td nzWidth="10%">
            <mat-icon class="material-symbols-outlined md-16">
              arrow_forward
            </mat-icon>
          </td>
          @if (data.translation) {
            <td>
              {{ data.translation | appCsvAttributeTranslationName: group }}
            </td>
          } @else {
            <td>
              <span
                class="color-orange"
                i18n="@@csvAttributeMappings.csvAttributeTable.notMapped"
                >Not mapped</span
              >
            </td>
          }
          @if (data.skip) {
            <td
              class="color-grey-100"
              i18n="@@csvAttributeMappings.csvAttributeTable.skippingMapping"
            >
              Skip mapping
            </td>
          } @else {
            @if (!data.hasBeenReviewed) {
              <td>
                <div fxLayout="row" fxLayoutAlign="start center">
                  <mat-icon
                    class="color-orange md-16"
                    fontSet="material-icons-outlined"
                    fxFlex="24px"
                    >info</mat-icon
                  >
                  @if (0 <= data.mappedValuesCount) {
                    <span
                      i18n="
                        @@csvAttributeMappings.csvAttributeTable.needsApprovalWithCount"
                    >
                      Needs approval ({{ data.mappedValuesCount }}/{{
                        data.values.length
                      }})
                    </span>
                  } @else {
                    <span
                      i18n="
                        @@csvAttributeMappings.csvAttributeTable.needsApproval"
                    >
                      Needs approval
                    </span>
                  }
                </div>
              </td>
            } @else {
              @if (0 <= data.mappedValuesCount) {
                @if (data.values.length === data.mappedValuesCount) {
                  <td>
                    <mat-icon class="color-teal-700 md-16" fxFlex="24px"
                      >check_circle</mat-icon
                    >
                    <span
                      i18n="
                        @@csvAttributeMappings.csvAttributeTable.approvedLength"
                      >Approved ({{ data.mappedValuesCount }} /
                      {{ data.mappedValuesCount }})</span
                    >
                  </td>
                } @else if (0 === data.mappedValuesCount) {
                  <td>
                    <mat-icon
                      class="material-symbols-outlined color-teal-700 md-16"
                      fxFlex="24px"
                      >check_circle</mat-icon
                    >
                    <span
                      i18n="
                        @@csvAttributeMappings.csvAttributeTable.zeroValuesApproved"
                      >Approved (0/{{ data.values.length }})</span
                    >
                    <mat-icon
                      class="color-orange md-16 u-paddingLeft-4"
                      fontSet="material-icons-outlined"
                      fxFlex="24px"
                      nz-tooltip
                      nzTooltipTitle="Unmapped values detected: Skipping mapping may result in inaccurate profiles and poorer match quality."
                      i18n-nzTooltipTitle="
                        @@csvAttributeMappings.csvAttributeTable.semireviewedApprovalTooltip"
                      >info</mat-icon
                    >
                  </td>
                } @else {
                  <td>
                    <mat-icon
                      class="material-symbols-outlined color-teal-700 md-16"
                      fxFlex="24px"
                      >check_circle</mat-icon
                    >
                    <span
                      i18n="
                        @@csvAttributeMappings.csvAttributeTable.approvedLength"
                      >Approved ({{ data.mappedValuesCount }}/{{
                        data.values.length
                      }})</span
                    >
                  </td>
                }
              } @else {
                <td>
                  <mat-icon class="color-teal-700 md-16" fxFlex="24px"
                    >check_circle</mat-icon
                  >
                  <span i18n="@@csvAttributeMappings.csvAttributeTable.approved"
                    >Approved</span
                  >
                </td>
              }
            }
          }
          <td>
            <div fxLayout="row" fxLayoutAlign="start center">
              <button
                (click)="openMappingSelectionDrawer(data)"
                class="c-button color-blue"
              >
                @if (data.hasBeenReviewed) {
                  <ng-container i18n="@@global.edit">Edit</ng-container>
                } @else {
                  <ng-container
                    i18n="@@csvAttributeMappings.csvAttributeTable.reviewCta"
                    >Review</ng-container
                  >
                }
              </button>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </nz-table>
</div>
<div
  [ngStyle]="{ padding: '16px 8px' }"
  class="u-width-100"
  fxLayout="row"
  fxLayoutAlign="end center"
>
  <button
    (click)="showConfirmationDialog()"
    color="primary"
    mat-raised-button
    i18n="@@global.continue"
  >
    Continue
  </button>
</div>
